import * as yup from 'yup';

export const lenderOrderPreExistingContactFormValidation = () =>
  yup.object({
    id: yup.string().required().nullable(),
    functions: yup.array().of(yup.string()).min(1).nullable(),
    email: yup.string().email().nullable().required(),
  });
